import ConfirmationModal from './ConfirmationModal';
import type { ConfirmationModalProps } from './types';

export default ConfirmationModal;
export type { ConfirmationModalProps };
